export default {
      id: "done-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "img/icons.792d8a78.svg#done-usage",
      toString: function () {
        return this.url;
      }
    }